import React, { useEffect, useState } from "react";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { filterWondersoftDrugs, getDrugById } from "core/services/api";
import Toast from 'components/Toast';

const TakeHomeMedicineRow = ({ takeHomeMedicineInfo,
  provider, readOnly, appointmentDetails, order, i, j, setTakeHomeMedicineInfo, title, handleChange, handleBlur, selectedInputValues, newMedicine, setSelectedInputValues, handleInputChange, adjustTextareaHeight, allDrugs, whens, handleBlurFreq, frequencies, setInputValueTake, setSelectedFreq, setShowToast, handleChangeDurationTake, handleInputChangeFreq, optionsTake
}: any): JSX.Element => {

  const [medicineOptions, updateMedicineOptions] = useState([])

  const [drugDosage, setDrugdosage] = useState<any>()
  const [showdrugValidation, setShowdrugvalidation] = useState(false)
  const fetchDosage = (drugId: any) => {
    getDrugById(drugId).then((res) => {
      setDrugdosage(res)
    })
  }

  const drugDosageValidation = (value: any) => {
    if (Object.keys(drugDosage).length > 0) {
      const numericValueDosage = parseFloat(drugDosage?.upperLimit?.match(/\d+/)[0]);
      const numericValue = parseFloat(value?.match(/\d+/)[0]);
      if (drugDosage?.upperLimit !== null && drugDosage?.lowerLimit !== null) {
        if (
          (numericValue > numericValueDosage)
        ) {
          setShowdrugvalidation(true)
        }
      }
    }
  }


  function fetchMedicine() {
    const temp = allDrugs?.map((each: any) => ({
      label: each?.brandName,
      value: each?.id,
    }))
    const sortedTemp = temp?.sort((a: any, b: any) => {
      if (a?.label?.toLowerCase() < b?.label.toLowerCase()) {
        return -1
      }
      if (a?.label.toLowerCase() > b?.label.toLowerCase()) {
        return 1
      }
      return 0
    })

    updateMedicineOptions(sortedTemp)
  }

  useEffect(() => {
    fetchMedicine()
  }, [allDrugs])

  const filterDrugType = (drugType: any, searchText: any) => {
    let url = "";
    if (drugType) {
      url = `?drugType=${drugType}`;
    }
    if (searchText) {
      if (url === "") {
        url = `?searchText=${searchText}`;
      } else {
        url = url + `&searchText=${searchText}`;
      }
    }

    filterWondersoftDrugs(url)
      .then((res: any) => {
        const temp = res?.map((each: any) => ({
          label: each?.brandName,
          value: each?.id,
        }))
        const sortedTemp = temp?.sort((a: any, b: any) => {
          if (a?.label?.toLowerCase() < b?.label.toLowerCase()) {
            return -1
          }
          if (a?.label.toLowerCase() > b?.label.toLowerCase()) {
            return 1
          }
          return 0
        })
        updateMedicineOptions(sortedTemp)
      })
      .catch((err: any) => {
        console.log("filter drug type error", err)
      })

  }

  return (
    <>
      < div className="dynamic-parent" key={j} ref={provider.innerRef} {...provider.draggableProps}>
        <div><div {...provider.dragHandleProps} className={`dynamic-child ${readOnly ? "read-only" : ""} ${(
          takeHomeMedicineInfo[i]?.isCancelled ? true : false || readOnly || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))
        ) ? "disabledDiv" : ""}`}
          style={{
            margin: "0px 0px 5px 0px",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center"
          }}>
          <img src="../../../../assets/images/drag-drop-icon.svg" style={{ marginBottom: "3px", marginRight: "5px" }} /> {j + 1}</div>
        </div>
        <div>


          <Select
            className={`dynamic-child ${readOnly ? "read-only" : ""} ${(
              takeHomeMedicineInfo[i]?.isCancelled ? true : false || readOnly || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))
            ) ? "disabledDiv" : ""}`}
            defaultValue={{
              label: "",
              value: ""
            }}
            value={{
              label: takeHomeMedicineInfo[i].medicines[j].type,
              value: ""
            }}
            name="type"
            options={
              (takeHomeMedicineInfo[i].medicines[j].typeOptions && takeHomeMedicineInfo[i].medicines[j].typeOptions.length > 0)
                ? takeHomeMedicineInfo[i].medicines[j].typeOptions.map((options: any) => ({
                  label: options,
                  value: options
                }))
                : title
            }
            onChange={(e: any) => {
              const values = [...takeHomeMedicineInfo]
              values[i].medicines[j].type = e?.value
              setTakeHomeMedicineInfo([...values]);
              filterDrugType(e?.value, "");
            }}
            isDisabled={takeHomeMedicineInfo[i]?.isCancelled ? true : false || readOnly || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}
          />


        </div>
        <div title={takeHomeMedicineInfo[i].medicines[j]?.medicineName}>

          <CreatableSelect
            styles={{}}
            isClearable
            isDisabled={takeHomeMedicineInfo[i]?.isCancelled ? true : false || readOnly || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}
            // defaultInputValue={eachPrescription?.medicineName}
            className={`dynamic-child med-name-style-chemo ${readOnly ? "read-only" : ""} ${(
              takeHomeMedicineInfo[i]?.isCancelled ? true : false || readOnly || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))
            ) ? "disabledDiv" : ""}`}

            value={
              takeHomeMedicineInfo[i]?.medicines[j]?.medicineName
                ? medicineOptions?.filter(
                  ({ label }) => label === takeHomeMedicineInfo[i].medicines[j]?.medicineName
                )?.length > 0 ? medicineOptions?.filter(
                  ({ label }) => label === takeHomeMedicineInfo[i].medicines[j]?.medicineName
                ) : { label: takeHomeMedicineInfo[i].medicines[j]?.medicineName, value: takeHomeMedicineInfo[i].medicines[j]?.medicineName }
                : newMedicine
            }
            onChange={(e: any) => {
              handleChange(e, i, j, "takeHomeMedicine");
              fetchDosage(e?.value);
              handleBlur("takeHome", i, j);
            }}
            onFocus={(e) => {
              handleInputChange("takeHome", i, j, takeHomeMedicineInfo[i].medicines[j]?.medicineName);
            }
            }
            inputValue={selectedInputValues?.takeHome?.[i]?.medicines?.[j]}
            onInputChange={(newValue: string) => {
              if (newValue !== undefined) {
                if (newValue.length >= 3) {
                  filterDrugType(takeHomeMedicineInfo[i].medicines[j]?.type, newValue);
                }
                const selected: any = { ...selectedInputValues };
                if (!selected["takeHome"][i]) {
                  selected["takeHome"][i] = { medicines: [] };
                }
                selected["takeHome"][i]["medicines"][j] = newValue;
                setSelectedInputValues(selected);
              } else {
                const selected: any = { ...selectedInputValues };
                selected["takeHome"][i]["medicines"][j] = "";
                setSelectedInputValues(selected);
              }
            }}
            options={medicineOptions}
            filterOption={(option: any, input: any) => option?.label?.toLowerCase()?.includes(input?.toLowerCase())}

          />
        </div>


        <div>
          <input
            style={{ whiteSpace: 'pre-wrap', padding: '5px 8px' }}
            value={takeHomeMedicineInfo[i].medicines[j].dose}
            className={`dynamic-child ${readOnly ? "read-only" : ""}`}
            name="dose"
            type="text"
            onChange={(e: any) => {
              const values = [...takeHomeMedicineInfo]
              values[i].medicines[j].dose = e.target.value
              setTakeHomeMedicineInfo([...values]);

            }}
            onBlur={(e: any) => {
              const values = [...takeHomeMedicineInfo]
              values[i].medicines[j].dose = e.target.value
              setTakeHomeMedicineInfo([...values]);
              drugDosageValidation(e.target.value);
            }}
            disabled={takeHomeMedicineInfo[i]?.isCancelled ? true : false || readOnly || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}
          />
        </div>
        <div>

          <CreatableSelect
            isClearable
            isDisabled={takeHomeMedicineInfo[i]?.isCancelled ? true : false || readOnly || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}
            // defaultInputValue={eachPrescription?.medicineName}
            className={`dynamic-child ${readOnly ? "read-only" : ""} ${(
              takeHomeMedicineInfo[i]?.isCancelled ? true : false || readOnly || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))
            ) ? "disabledDiv" : ""}`}

            value={{
              label: takeHomeMedicineInfo[i].medicines[j].when,
              value: ""
            }}
            onChange={(e: any) => {
              const values = [...takeHomeMedicineInfo]
              values[i].medicines[j].when = e?.value
              setTakeHomeMedicineInfo([...values]);

            }}
            options={whens}
            filterOption={(option: any, input: any) => option?.label?.toLowerCase()?.includes(input?.toLowerCase())}

          />


        </div>
        <div>


          <CreatableSelect
            isClearable
            isDisabled={takeHomeMedicineInfo[i]?.isCancelled ? true : false || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}
            // defaultInputValue={eachPrescription?.medicineName}
            className={`dynamic-child ${readOnly ? "read-only" : ""} ${(
              takeHomeMedicineInfo[i]?.isCancelled ? true : false || readOnly || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))
            ) ? "disabledDiv" : ""}`}

            value={{
              label: takeHomeMedicineInfo[i].medicines[j].frequency,
              value: ""
            }}
            onChange={(e: any) => {
              const values = [...takeHomeMedicineInfo]
              values[i].medicines[j].frequency = e?.value
              setTakeHomeMedicineInfo([...values]);
              handleBlurFreq("freq", i, j);
              if (e?.value !== "") {
                if (!frequencies.map((option: any) => option.value).includes(e?.value)) {
                  console.log("inside if ", e?.value)
                  setSelectedFreq(e?.value)
                  setShowToast(true);
                } else {
                  setShowToast(false);
                }
              }
            }}
            onFocus={(e) => {
              handleInputChangeFreq("freq", i, j, takeHomeMedicineInfo[i].medicines[j]?.frequency);
            }}
            inputValue={selectedInputValues?.freq?.[i]?.freq?.[j]}
            onInputChange={(newValue: string) => {
              if (newValue !== undefined) {
                const selected: any = { ...selectedInputValues };
                if (!selected["freq"][i]) {
                  selected["freq"][i] = { freq: [] };
                }
                selected["freq"][i]["freq"][j] = newValue;
                setSelectedInputValues(selected);
              }
              else {
                const selected: any = { ...selectedInputValues };
                selected["freq"][i]["freq"][j] = "";
                setSelectedInputValues(selected);
              }
            }}
            options={frequencies}
            filterOption={(option: any, input: any) => option?.label?.toLowerCase()?.includes(input?.toLowerCase())}

          />

        </div>

        <div>
          <Select
            id="take-home-notes"
            value={{
              label: takeHomeMedicineInfo[i].medicines[j].duration,
              value: takeHomeMedicineInfo[i].medicines[j].duration
            }}
            className={`dynamic-child ${readOnly ? "read-only" : ""} ${(
              takeHomeMedicineInfo[i]?.isCancelled ? true : false || readOnly || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))
            ) ? "disabledDiv" : ""}`}
            name="duration"
            onChange={(e: any) => {
              const values = [...takeHomeMedicineInfo]
              values[i].medicines[j].duration = e.value
              setTakeHomeMedicineInfo([...values]);
              setInputValueTake(e ? e.value : '');
            }}
            onInputChange={(inputValue: any) => handleChangeDurationTake({ value: inputValue, label: inputValue })}
            options={optionsTake}
            isDisabled={takeHomeMedicineInfo[i]?.isCancelled ? true : false || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}
          />
        </div>
        <div>
          <textarea
            rows={1}
            id="take-home-notes"
            style={{
              minHeight: "100%", whiteSpace: 'pre-wrap', padding: "5px 8px", display: "flex",
              alignItems: "center",
              overflow: "hidden",
              resize: "none"
            }}
            value={takeHomeMedicineInfo[i].medicines[j].instructions}
            className={`autoHeightTextarea dynamic-child ${readOnly ? "read-only" : ""}`}
            name="instructions"
            onChange={(e: any) => {
              const values = [...takeHomeMedicineInfo]
              values[i].medicines[j].instructions = e.target.value

              setTakeHomeMedicineInfo([...values]);
              adjustTextareaHeight();
            }}
            disabled={takeHomeMedicineInfo[i]?.isCancelled ? true : false || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}
          />
        </div>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <input
            type="checkbox"
            //value={takeHomeMedicineInfo[i].medicines[j].sideEffectCheck}
            checked={
              takeHomeMedicineInfo[i]?.medicines[j]?.sideEffectCheck
            }
            //className={`dynamic-child ${readOnly ? "read-only" : ""}`}
            name="route"
            onChange={(e: any) => {
              const values = [...takeHomeMedicineInfo]
              values[i].medicines[j].sideEffectCheck = e.target.checked

              setTakeHomeMedicineInfo([...values]);
            }}
            disabled={takeHomeMedicineInfo[i]?.isCancelled ? true : false || readOnly || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}
          />


        </div>
        {takeHomeMedicineInfo[i].medicines.length > 1 ? (
          !readOnly && (
            <button
              className="delete-icon"
              onClick={() => {

                const values = [...takeHomeMedicineInfo]
                if (values[i].medicines.length > 1) {
                  values[i].medicines.splice(j, 1)
                  setTakeHomeMedicineInfo(values)

                  const selected: any = { ...selectedInputValues }
                  selected["takeHome"][i]["medicines"].splice(j, 1)

                  selected["freq"][i]["freq"].splice(j, 1)

                  setSelectedInputValues(selected)
                }

              }}
              disabled={takeHomeMedicineInfo[i]?.isCancelled ? true : false || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}
            >
              <img
                src="../../../../assets/images/delete-icon.svg"
                alt=""
              />
            </button>
          )) : (
          !readOnly && (
            <button
              className="delete-icon"
              style={{ cursor: "not-allowed" }}
            >
              <img
                src="../../../../assets/images/delete-icon.svg"
                alt=""
              />
            </button>)
        )
        }
      </div>
      {showdrugValidation && (
        <Toast
          textMessage={`Check the UpperLimit ${drugDosage?.upperLimit === null ? "" : drugDosage?.upperLimit} `}
          onCloseText={"Close"}
          type={"error"}
          onClose={() => setShowdrugvalidation(false)}
        ></Toast>
      )}
    </>
  )

}

export default TakeHomeMedicineRow